module.exports = __webpack_public_path__ + "static/media/supplies.981e4ed6.svg";